var _style, _g, _line, _line2, _line3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#83858c;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:#83858c;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,18.6c0,3.3-2.7,6-6,6H11c-3.3,0-6-2.7-6-6v-1c0-3.3,2.7-6,6-6h10c3.3,0,6,2.7,6,6V18.6z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 7.4,
    x2: 16,
    y2: 11.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.5,
    y1: 16,
    x2: 10.5,
    y2: 20.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.7,
    y1: 18.1,
    x2: 8.4,
    y2: 18.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 16.8,
    r: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 22.7,
    cy: 19.5,
    r: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameHistory);
export default __webpack_public_path__ + "static/media/gameHistory.6617079f1cade2ceb9801eff0b612f63.svg";
export { ForwardRef as ReactComponent };